import { purify } from '@vfit/shared/themes';
import { ImageAtoms, Svg } from '@vfit/shared/atoms';
import Link from 'next/link';
import * as S from './downloadAncorCard.style';
import { DownloadAnchorCardProps } from './downloadAnchorCard.models';

/**
 * A component that renders a download card. The component takes in a title, an
 * icon, a description, and a download link. The component will render a card
 * with an image, title, description, and a download icon. The download icon
 * will link to the download link.
 *
 * @example
 * <DownloadAnchorCard
 *   title="Download Card"
 *   icon="/images/download.svg"
 *   description="This is a download card"
 *   downloadLink="https://example.com/download.pdf"
 * />
 */
export const DownloadAnchorCard = ({
  title,
  icon,
  description,
  downloadLink,
  shortCard,
}: DownloadAnchorCardProps) => {
  const [purifiedDescription] = purify([description]);

  return (
    <S.Container shortCard={shortCard}>
      <S.ContentContainer>
        {icon && (
          <S.ImgWrapper>
            <ImageAtoms image={icon} nameCard={`download-card-${title}`} />
          </S.ImgWrapper>
        )}
        <S.Content>
          {title && <S.Title>{title}</S.Title>}
          {purifiedDescription && (
            <S.Description
              dangerouslySetInnerHTML={{
                __html: purifiedDescription,
              }}
            />
          )}
        </S.Content>
      </S.ContentContainer>
      {downloadLink && (
        <Link href={downloadLink} target="_blank" rel="noreferrer">
          {/* <a target="_blank" href={downloadLink} rel="noreferrer"> */}
          <Svg name="download" width={24} height={24} />
          {/* </a> */}
        </Link>
      )}
    </S.Container>
  );
};

